import { render, staticRenderFns } from "./mailing-not-senders-page.vue?vue&type=template&id=5dab9747&"
import script from "./mailing-not-senders-page.vue?vue&type=script&lang=js&"
export * from "./mailing-not-senders-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports